export enum ParamsNames {
  GOOGLE = "google",
  CLIENT_NAME = "client_name",
  CLIENT_IDENTIFIER = "client_identifier",
  SECONDS_FOR_UNDUE_STOP = "seconds_for_undue_stop",
  SECONDS_FOR_IMPROPER_DISCHARGE = "seconds_for_improper_discharge",
  PUMP_TIMELINE_ENABLED = "pump_timeline_enabled",
  BLOCK_DATE = "block_date",
  AZURE_CLIENT_ID = "azure_client_id",
  AZURE_TENANT_ID = "azure_tenant_id",
  AZURE_CLIENT_SECRET = "azure_client_secret",
  AZURE_SSO_ENABLED = "azure_sso_enabled",
  DEFAULT_CONSTRUCTION_RADIUS = "default_construction_radius",
  WATER_POST_DISCHARGE_NEXT_TRAVEL_ENABLED = "water_post_discharge_next_travel_enabled",
  AUTO_TRAVEL_CONSTRUCTION_MIN_STOP_MINUTES = "auto_travel_construction_min_stop_minutes",
  OWN_GEO_SERVERS_ENABLED = "own_geo_servers_enabled"
}

export enum ParamsKeys {
  PUMP_TIMELINE_ENABLED_TRUE = "y",
  PUMP_TIMELINE_ENABLED_FALSE = "n",
  WATER_POST_DISCHARGE_NEXT_TRAVEL_ENABLED_TRUE = "y",
  WATER_POST_DISCHARGE_NEXT_TRAVEL_ENABLED_FALSE = "n",
  OWN_GEO_SERVERS_ENABLED_TRUE = "y",
  OWN_GEO_SERVERS_ENABLED_FALSE = "n"
}
